(function () {
    'use strict';
    angular.module('emarket.main.category').directive('emCategories', ['$log', 'Category', function ($log, Category) {
        var directive = {
            scope: {
                category: '=ngModel'
            },
            templateUrl: 'main/category/directive/template.tpl.html',
            controller: [ '$scope', function ($scope) {
                $scope.cats = [];
                $scope.categoryList = [];
                $scope.updateCategory = function (id, index) {
                    Category.$search({
                        parentId: id
                    })
                        .$asPromise()
                        .then(function (categories) {
                            $scope.categoryList = $scope.categoryList.slice(0, index + 1);
                            if (categories.length > 0) {
                                $scope.categoryList.push(categories);
                            } else {
                                var category = $scope.categoryList[$scope.categoryList.length - 1].filter(function (cat) {
                                    return cat._id === id;
                                })[0];
                                var plainCategory = {};
                                Object.keys(category).forEach(function (key) {
                                    if (!/^\$/.test(key)) {
                                        plainCategory[key] = category[key];
                                    }
                                });
                                $scope.category = plainCategory;
                            }
                        });
                };
                Category.$search({
                    parentId: 0
                }).$asPromise().then(function (categories) {
                    $scope.categoryList.push(categories);
                });
            } ],
            link: function (scope, element, attrs) {
                if (attrs.isRequired) {
                    scope.isRequired = true;
                }
                element.attr('layout', 'row');
            }
        };
        return directive;
    }]);
}());
